<template>
  <div
    v-if="hasAnySlot"
    class="slot-switcher"
  >
    <transition
      mode="out-in"
      name="fade-content"
    >
      <div :key="resolvedIndex">
        <slot :name="`item-${resolvedIndex}`" />
      </div>
    </transition>

    <span
      v-if="slotCount > 1"
      class="switch-icon"
      @click.stop="onSwitchToggle"
    >
      <gl-icon
        :class="{ 'switch-icon--spinning': localLoading || loading }"
        :height="20"
        name="I-S-Change"
        :width="20"
      />
    </span>
  </div>
</template>

<script>
// components
import GlIcon from '@/components/gl-icon'

export default {
  name: 'SlotSwitcher',
  components: {
    GlIcon,
  },
  props: {
    activeIndex: {
      type: Number,
      default: 0,
    },
    loading: { type: Boolean, default: false },
    global: { type: Boolean, default: false },
  },
  data() {
    return { localLoading: false }
  },
  computed: {
    slotNames() {
      return Object.keys(this.$slots).filter(name => name.startsWith('item-'))
    },
    slotCount() {
      return this.slotNames.length
    },
    hasAnySlot() {
      return this.slotCount > 0
    },
    resolvedIndex() {
      if (this.slotNames.includes(`item-${this.activeIndex}`)) {
        return this.activeIndex
      }
      return this.slotCount > 0 ? 0 : null
    },
  },
  methods: {
    onSwitchToggle() {
      this.$emit('toggle')
      if (this.localLoading) return
      if (this.global) return
      this.startSpin()
    },
    startSpin() {
      this.localLoading = true
      setTimeout(() => {
        this.localLoading = false
      }, 600)
    },
  },
}
</script>

<style scoped>
.slot-switcher {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 14px;
  color: #4a4a6a;
}
.switch-icon {
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  font-size: 14px;
  user-select: none;
}
.switch-icon--spinning {
  animation: spinScale 0.6s ease-in-out;
}

@keyframes spinScale {
  0% {
    transform: rotate(0deg) scale(0.95);
  }
  50% {
    transform: rotate(90deg) scale(1.05);
  }
  100% {
    transform: rotate(180deg) scale(1);
  }
}

.fade-content-enter-active,
.fade-content-leave-active {
  transition: opacity 0.3s ease;
}

.fade-content-enter,
.fade-content-leave-to {
  opacity: 0.6;
}
</style>
